import { useLocation } from 'react-router-dom';
import agencyFields from '../config/agencyFields.json';

export const useCanonical = () => {
    const location = useLocation();
    const runtimeOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    
    // Prendiamo il dominio dal file di configurazione
    const domain = agencyFields.siteDomain || runtimeOrigin;

    // Rimozione di eventuali 'http://' o 'https://' per sicurezza
    const cleanDomain = domain.replace(/^(https?:\/\/)/, '');

    // Costruzione dell'URL canonico:
    // 1. Usa sempre https.
    // 2. Usa il dominio pulito.
    // 3. Usa il pathname SENZA parametri di query. Questo è FONDAMENTALE.
    //    In questo modo, /immobili?prezzo_min=100 punta a /immobili.
    const canonicalUrl = `https://${cleanDomain}${location.pathname}`;

    return canonicalUrl;
};
